export enum Theme {
    DigitalPractice = '0',
    Provet = '1'
} 